import { render, staticRenderFns } from "./JerseySvg.vue?vue&type=template&id=2100052d&"
import script from "./JerseySvg.vue?vue&type=script&lang=ts&"
export * from "./JerseySvg.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports